<template>
    <div class="sidebar" :class="sidebarSelectedFilter.class">
        <vue-perfect-scrollbar class="scroll-area" :settings="settings">
            <v-toolbar flat class="transparent scroll-area navigation">
                <v-list>
                    <app-logo></app-logo>
                    <user-block></user-block>

                    <div class="boxListMenu_1">
                        <ul>
                            <template v-for="(item, index) in menuList">
                                <li
                                    v-if="item.children == null"
                                    :key="index"
                                    :class="setClass(item.class)"
                                >
                                    <template
                                        v-if="item.code == 'smartdata_menu'"
                                    >
                                        <a
                                            class="menuTitle"
                                            :href="`${item.path}`"
                                            target="_blank"
                                        >
                                            <i
                                                class="mr-2"
                                                :class="setClass(item.icon)"
                                            ></i>
                                            <span>{{
                                                textTruncate($t(item.title))
                                            }}</span>
                                        </a>
                                    </template>
                                    <template v-else>
                                        <router-link
                                            class="menuTitle"
                                            :to="`${item.path}`"
                                            active-class="is-active"
                                        >
                                            <i
                                                class="mr-2"
                                                :class="setClass(item.icon)"
                                            ></i>
                                            <span>{{
                                                textTruncate($t(item.title))
                                            }}</span>
                                        </router-link>
                                    </template>
                                </li>

                                <li
                                    v-else
                                    :key="index"
                                    class="hasSubMenu"
                                    :class="setClass(item.class)"
                                >
                                    <!-- <router-link class="menuTitle" :to="`${item.path}`" active-class="is-active"> -->
                                    <a
                                        class="menuTitle"
                                        @click="
                                            $event.target.classList.toggle(
                                                'is-active'
                                            )
                                        "
                                    >
                                        <i
                                            class="mr-2"
                                            :class="setClass(item.icon)"
                                        ></i>
                                        <span>{{
                                            textTruncate($t(item.title))
                                        }}</span>
                                    </a>
                                    <!-- </router-link> -->

                                    <ul>
                                        <li
                                            v-for="(subItem,
                                            subItemKey) in item.children"
                                            :key="subItemKey"
                                        >
                                            <router-link
                                                class="menuTitle"
                                                :to="`${subItem.path}`"
                                                active-class="is-active"
                                            >
                                                <span>{{
                                                    $t(subItem.title)
                                                }}</span>
                                            </router-link>
                                            <ul v-if="subItem.children != null">
                                                <li
                                                    v-for="(widget,
                                                    widgetKey) in subItem.children"
                                                    :key="widgetKey"
                                                >
                                                    <router-link
                                                        class="menuTitle"
                                                        :to="`${widget.path}`"
                                                        active-class="is-active"
                                                    >
                                                        <span>{{
                                                            widget.title
                                                        }}</span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </template>
                        </ul>
                    </div>
                </v-list>
            </v-toolbar>
        </vue-perfect-scrollbar>
    </div>
</template>

<style scoped>
.boxListMenu_1 > ul > li > .menuTitle {
    text-overflow: unset;
}
.boxListMenu_1 > ul > li.menu-dashboard > .menuTitle:after {
    content: unset;
}
</style>
<script>
import UserBlock from './UserBlock'
import { textTruncate, getCurrentAppLayout } from 'Helpers/helpers'
import AppLogo from 'Components/AppLogo/AppLogo'

import axios from 'axios'
import { mapGetters } from 'vuex'
import {
    API_ENDPOINT_URL,
    ADMIN_ROLE_ID,
    PREFIX_ADMIN_PATH,
} from '@/config/api_config'

import {
    emails_group_it,
    emails_group_special,
} from '@/assets/jsondata/auth_list.json'

export default {
    data() {
        return {
            menuList: {},
            show_menu: false,
            settings: {
                maxScrollbarLength: 160,
            },
            isActive: false,
        }
    },
    components: {
        UserBlock,
        AppLogo,
    },
    computed: {
        ...mapGetters(['sidebarSelectedFilter', 'menus', 'menusAD', 'getUser']),
    },
    beforeMount() {
        this.checkIsAdmin()
    },
    created() {
        this.$store.dispatch('getWidgetMenu')
        this.$store.dispatch('setDashboardMenus')
    },
    mounted() {
        // this.$store.dispatch("setActiveMenuGroup", this.$router);
    },
    methods: {
        myFilter: function() {
            this.isActive = !this.isActive
            // some code to filter users
        },
        textTruncate(text) {
            return textTruncate(text, 50)
        },
        setClass: function(strClass) {
            return strClass
        },
        async checkIsAdmin() {
            let roleID = null

            let user_storage =
                typeof localStorage.getItem('user') !== 'undefined'
                    ? JSON.parse(localStorage.getItem('user'))
                    : null
            let user = (await this.getUser) || null
            let role_storage =
                typeof user.role !== 'undefined' ? user.role : null
            let role_auth =
                typeof this.getUser.role !== 'undefined' &&
                role_storage != this.getUser.role
                    ? this.getUser.role
                    : role_storage

            if (user != null) {
                roleID = role_auth
            }

            if (ADMIN_ROLE_ID == roleID) {
                this.show_menu = true
            }

            // check for set menu to show user from AD or User inside this db
            if (
                this.$store.state.auth.user.type == 'normal_auth' ||
                typeof this.$store.state.auth.user.type === 'undefined'
            ) {
                // case inside
                this.menuList = this.menus
            } else if (user_storage.type == 'ad_auth') {
                let levelAD =
                    typeof user_storage.department !== 'undefined' &&
                    user_storage.department.level !== 'undefined'
                        ? user_storage.department.level
                        : null
                levelAD =
                    levelAD !== null
                        ? levelAD.match(/[\d]+$/gi) !== null &&
                          typeof levelAD.match(/[\d]+$/gi)[0] !== 'undefined'
                            ? parseInt(levelAD.match(/[\d]+$/gi)[0])
                            : 0
                        : 0

                let menuRoles = []
                if (levelAD >= 9) {
                    // case perm_01 more than level AD C9 up
                    const menu_perm1 = this.menusAD.filter(
                        res =>
                            typeof res.permission_group !== 'undefined' &&
                            res.permission_group.includes('perm_01')
                    )
                    menuRoles.push(...menu_perm1)
                } else if (emails_group_it.includes(user_storage.email)) {
                    // case perm_03 for email information technology group only
                    const menu_perm3 = this.menusAD.filter(res =>
                        res.permission_group.includes('perm_03')
                    )
                    menuRoles.push(...menu_perm3)
                } else if (emails_group_special.includes(user_storage.email)) {
                    // case perm_04 for email special group only
                    const menu_perm4 = this.menusAD.filter(res =>
                        res.permission_group.includes('perm_04')
                    )
                    menuRoles.push(...menu_perm4)
                } else {
                    // case perm_02 for user type AD only
                    const menu_perm2 = this.menusAD.filter(res =>
                        res.permission_group.includes('perm_02')
                    )
                    menuRoles.push(...menu_perm2)
                }

                // case AD
                this.menuList = menuRoles
            }
        },
        logoutUser(path) {
            if (path == '/logout') {
                this.$store.dispatch('logoutUser', this.$router)
            }
        },
        getCurrentAppLayoutHandler() {
            return getCurrentAppLayout(this.$router)
        },
    },
}
</script>
